import useExternalScript from "../../hooks/useExternalScript";

const GetSocialMedia = () => {
    window.__sharethis__ = null;
    useExternalScript({
        url: "//platform-api.sharethis.com/js/sharethis.js#property=64219999886bea00193ba815&product=inline-share-buttons&source=platform",
        type: "text/javascript",
        isAsync: true
    });

    return <div className="sharethis-inline-share-buttons"></div>
}

export default GetSocialMedia;
